import * as React from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import { BillingPaymentsList } from 'features/BillingPayments/BillingPaymentsList'

export interface IBillingPaymentsProps {
  location: {
    query: {
      page?: string
      ban?: string
    }
  }
}

export class BillingPayments extends React.Component<IBillingPaymentsProps> {
  render() {
    const { location } = this.props
    return (
      <Page layout={{ header: 'app' }} title="Payments">
        <PageHeader>
          <Crumbs title="Billing">
            <Crumb to="/dashboard/billing">Bills</Crumb>
            <Crumb active to="/dashboard/billing/payments">
              Payments
            </Crumb>
            <Crumb to="/dashboard/billing/accounts">Accounts</Crumb>
          </Crumbs>
        </PageHeader>
        <Container paddingTop paddingBottom>
          <BillingPaymentsList
            page={parseInt(location.query.page || '1', 10)}
            ban={location.query.ban}
          />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/BillingPayments/BillingPayments.tsx